exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.preview-slot[data-v-2e646be0] {\n    display: flex;\n    flex-direction: column;\n    justify-content: flex-end;\n    height: 38vh;\n    width: 100%;\n    overflow-y: auto;\n    background: repeat url(/images/background-wpp.png) #e6ded5;\n    background-size: 80%;\n    background-blend-mode: soft-light;\n}\n.template-preview[data-v-2e646be0] {\n    width: 60%;\n    align-self: flex-start;\n    text-align: start;\n    margin: 10px;\n    background-color: white;\n    padding: 5px;\n    border-radius: 5px;\n}\n", ""]);

// exports
